<template>
  <v-dialog
    v-model="display"
    persistent
    width="450"
  >
    <v-card
      color="white"
      style="text-align:center;"
    >
      <div style="width:450px;height:130px;">
        <v-icon
          style="font-size:125px;margin:10px;"
          class="cc-icon"
          color="primary"
        >
          announcement
        </v-icon>
      </div>
      <v-card-text>
        <span style="font-weight:500;font-size:24px;">Service Maintenance</span><br /><br />
        <span>
          <i>Please pardon the interruption. {{ app_name }} is currently undergoing routine maintenance.</i><br />
          <br />
          <b>{{ app_name }} currently cannot save any responses. Please try again later.</b>
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="unloadAndReload()"
          flat
          color="blue"
        >
          Refresh
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      display: true
    }
  },
  methods: {
    unloadAndReload () {
      window.onbeforeunload = null
      this.$store.state.userform.handleBypass = true
      this.$router.go()
    }
  }
}
</script>
